// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceAndReviews_container__mLX8f","wrapOnMobile":"PriceAndReviews_wrapOnMobile__wyWqY"};